import React, { useEffect, useRef } from "react";
import styles from "./IntroVideoBottomSheet.module.scss";
import BuyNowFooter from "@src/layout/BuyNowFooter";
import { useSelector, useDispatch } from "react-redux";
// import Player from "@src/ReactPlayer/Player";
import { updateIntroVideo } from "./store/service";
import CONSTANTS from "../../store/constants";
import VideoPlayer from "@src/ReactPlayer/VideoPlayer";

export default function IntroVideoBottomSheet() {
  const sheetRef = useRef(null);
  const dispatch = useDispatch();
  const state = useSelector((state) => state?.overviewReducer?.overViewDetails?.course) || {};
  const introVideoData = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.introVideoData || {}
  );
  const showIntroVideoBottomSheet = useSelector(
    (state) => state?.bottomSheetReducer?.showIntroVideoBottomSheet || 0
  );
  const isOpen = showIntroVideoBottomSheet === 1;

  const keypoints = Object.values(introVideoData?.keypoints).filter((keypoint) => keypoint.length > 0) || [];
  const videoUrl = introVideoData?.videoUrl || "";

  // Prevent background scroll when open
  useEffect(() => {
    // Prevent closing on Escape key
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        e.stopPropagation();
        e.preventDefault();
      }
    };
    if (isOpen) {
      document.body.style.overflow = "hidden";
      window.addEventListener("keydown", handleKeyDown, true);
      window.__INTRO_VIDEO_BOTTOM_SHEET_OPEN__ = true;
    } else {
      document.body.style.overflow = "";
      window.__INTRO_VIDEO_BOTTOM_SHEET_OPEN__ = false;
    }
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", handleKeyDown, true);
      window.__INTRO_VIDEO_BOTTOM_SHEET_OPEN__ = false;
    };
  }, [isOpen]);

  // // Close on backdrop click
  // const handleBackdropClick = (e) => {
  //   if (e.target === e.currentTarget) handleClose();
  // };

  // Close handler: set Redux value to 0
  const handleClose = async () => {
    dispatch({
      type: CONSTANTS.SET_SHOW_INTRO_VIDEO_BOTTOM_SHEET,
      payload: 0,
    });

    // Call intro-video-watched API on close
    const courseId = introVideoData?.courseId;
    const introVideoId = introVideoData?.contentId || introVideoData?.id;
    const token = localStorage.getItem("userToken");
    await updateIntroVideo({ courseId, introVideoId, token });
  };
  if (!isOpen) return null;

  // Prevent closing on backdrop click
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      // Do nothing
      return;
    }
  };

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div className={styles.sheet} ref={sheetRef}>
        <button className={styles.closeBtn} onClick={handleClose} aria-label="Close">&times;</button>
        {(
          introVideoData?.contentId
        ) && (
          <div className={styles.header}>
            <img src="https://cdn-cp-assets-public.classplus.co/campaigns-assets/web/courseWebview/content/intro.png" />
            {introVideoData?.title ? <h2 className={styles.title}>{introVideoData?.title}</h2> : null}
            {introVideoData?.subtitle ? <p className={styles.subtitle}>{introVideoData?.subtitle}</p> : null}
          </div>
        )}
        {introVideoData?.contentId && (
          <div className={styles.videoSection}>
            <div className={styles.rotatedPlayerWrapper}>
              <VideoPlayer
                item={{
                  contentHashId: introVideoData.contentHashId || "U2FsdGVkX19rhNGVmk/1SVPHp/C4fGjzgGcivuTxQoQ=",
                  id: introVideoData.contentId,
                  url: null,
                  vidKey: introVideoData.key,
                  videoType: "jw-hosted",
                  autoplay: true
                }}
                hashKey={introVideoData.contentHashId}
              />
            </div>
          </div>
        )}
        {(introVideoData?.heading || introVideoData?.subheading) && (
          <div className={styles.highlightBox}>
            {introVideoData?.heading ? <div className={styles.highlightTitle}>{`✨ ${introVideoData?.heading} ✨`}</div> : null}
            {introVideoData?.subheading ? <div className={styles.highlightSub}>{introVideoData?.subheading}</div> : null}
          </div>
        )}
        {keypoints.length > 0 && (
          <div className={styles.featuresGrid}>
            {keypoints.map((keypoint, index) => (
              <FeatureCard
                key={index}
                icon="https://cdn-cp-assets-public.classplus.co/campaigns-assets/web/courseWebview/content/tick-circle.png"
                text={keypoint}
              />
            ))}
          </div>
        )}
        {/* <div className={styles.spacer} />  */}
        <div className={styles.buyNowFooterSticky}>
          <BuyNowFooter 
          isFreeCourse = {state?.metaData?.isFreeCourse || 0}
          />
        </div>
      </div>
    </div>
  );
}

function FeatureCard({ icon, text, text2 }) {
  return (
    <div className={styles.featureCard}>
      <div className={styles.featureIcon}>
        <img src={icon} alt="feature icon" />
      </div>
      <div className={styles.featureText}>
        <span>{text}</span>
      </div>
    </div>
  );
}